import { datadogRum, type DefaultPrivacyLevel } from '@datadog/browser-rum-slim'
import {
  ENV_APP_VERSION,
  ENV_DATADOG_RUM_APP_ENV,
  ENV_DATADOG_RUM_APP_ID,
  ENV_DATADOG_RUM_APP_NAME,
  ENV_DATADOG_RUM_APP_TOKEN,
  ENV_ENABLE_DD_RUM,
  ENV_ENABLE_DD_RUM_DEBUG,
} from '../env.ts'
import { redactValuesFromLogs } from './redactValuesFromLogs.ts'

const DATADOG_DEBUG_EVENT_TYPES = ['action', 'error']

type DatadogRumOptions = {
  sessionSampleRate?: number
  sessionReplaySampleRate?: number
  trackUserInteractions?: boolean
  trackResources?: boolean
  trackLongTasks?: boolean
  defaultPrivacyLevel?: DefaultPrivacyLevel
}

export class DatadogRUM {
  private static isInitialized = false

  public static initialize(options?: DatadogRumOptions) {
    if (!this.isInitialized) {
      datadogRum.init({
        applicationId: ENV_DATADOG_RUM_APP_ID,
        clientToken: ENV_DATADOG_RUM_APP_TOKEN,
        site: 'datadoghq.com',
        service: ENV_DATADOG_RUM_APP_NAME,
        env: ENV_DATADOG_RUM_APP_ENV,
        version: ENV_APP_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        actionNameAttribute: 'data-testid',
        beforeSend(event, context) {
          const isRumEnabled = ENV_ENABLE_DD_RUM === 'true'
          const isRumDebugEnabled = ENV_ENABLE_DD_RUM_DEBUG === 'true'

          if (
            isRumDebugEnabled &&
            DATADOG_DEBUG_EVENT_TYPES.includes(event.type)
          ) {
            console.group('=== RUM DEBUG ===')
            console.log('Type: ', event.type)
            console.log(
              'Message: ',
              JSON.stringify(event.action) || JSON.stringify(event.error) || '',
            )
            console.log('Custom properties: ', event.context)
            console.log('All properties: ', { event, context })
            console.log(
              'Was sent to datadog: ',
              isRumEnabled || 'false (DD RUM is disabled)',
            )
            console.groupEnd()
          }

          if (!isRumEnabled) {
            return false
          }

          redactValuesFromLogs(event)
          redactValuesFromLogs(context)
          return true
        },
        ...options,
      })
      this.isInitialized = true
    }
  }

  public static setUser(email: string) {
    if (DatadogRUM.isInitialized) {
      datadogRum.setUser({ email })
    }
  }

  public static addCustomAction: typeof datadogRum.addAction = (
    name,
    context,
  ) => {
    if (DatadogRUM.isInitialized) {
      datadogRum.addAction(name, context)
    }
  }
}
